/**
 * Light / dark switch.
 *
 * Cycles light → dark → follow the system, rather than just flipping between
 * two. "Follow the system" is the default and the best setting for most
 * people, so there has to be a way back to it once someone has overridden it.
 */

import { useTheme } from '../../context/index.js'
import './ThemeToggle.css'

const NEXT = { light: 'dark', dark: null }
const LABEL = {
  light:  'Light',
  dark:   'Dark',
  system: 'System'
}

export default function ThemeToggle ({ className = '' }) {
  const { preference, isDark, isFollowingSystem, setTheme } = useTheme()

  const state = isFollowingSystem ? 'system' : preference
  const next = isFollowingSystem ? 'light' : NEXT[preference]

  return (
    <button
      type="button"
      className={`tt ${className}`}
      onClick={() => setTheme(next)}
      aria-label={`Theme: ${LABEL[state]}. Click to change.`}
      title={`Theme: ${LABEL[state]}`}
    >
      <span className="tt__icon" aria-hidden="true">
        {state === 'system' ? (
          // A half-filled circle: the page follows whatever the device says.
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
            <path d="M12 3.5a8.5 8.5 0 0 1 0 17Z" fill="currentColor" />
          </svg>
        ) : isDark ? (
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z"
              stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="4.6" stroke="currentColor" strokeWidth="1.8" />
            <path
              d="M12 2.4v2.2M12 19.4v2.2M2.4 12h2.2M19.4 12h2.2M5.2 5.2l1.6 1.6M17.2 17.2l1.6 1.6M5.2 18.8l1.6-1.6M17.2 6.8l1.6-1.6"
              stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
            />
          </svg>
        )}
      </span>

      <span className="tt__label">{LABEL[state]}</span>
    </button>
  )
}
